import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import RangerJack from '../../characters/RangerJack';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { AbstractionData } from '../..';
import { t } from 'ttag';

const GoodbyeMessage: React.FC<ISlide<AbstractionData>> = ({ nextSlide, defaultHeader, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue = [
        {
            character: RangerJack,
            text: t`Ok, well thank you ${data.name} for all your help and I hope to see you again soon. You are always welcome here!`,
            buttonText: t`Thanks Jack!`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default GoodbyeMessage;
